export default {
  created: function() {},
  data: function() {
    return {
      deliveryApproveOptions: [
        { label: "Przyjęte", value: true },
        { label: "Nie przyjęte", value: false },
      ],
      isPackedHermeticallyOptions: [
        { label: "Hermetycznie", value: true },
        { label: "Niehermetycznie", value: false },
      ],
      packageTypeOptions: [
        { label: "Folia / Plastik", value: 0 },
        { label: "Papier", value: 1 },
        { label: "Metal", value: 2 },
      ],
      deliveryPackageTypeOptions: [
        { label: "Worek", value: 0 },
        { label: "Folia", value: 1 },
        { label: "Karton", value: 2 },
        { label: "Baniak / Beczka", value: 3 },
      ],
      invoiceTypeOptions: [
        { label: "Faktura", value: 0 },
        { label: "Wz", value: 1 },
      ],
      yesNoOptions: [
        { label: "Tak", value: true },
        { label: "Nie", value: false },
      ],
      packingPlaces: [
        { label: "Magazyn pośredni", value: 0 },
        { label: "Magazyn z produktami", value: 1 },
      ],
      productVisibilityFilter: [
        { label: "Pokaż wszystkie produkty", value: 0 },
        { label: "Pokaż produkty na półce", value: 1 },
        { label: "Pokaż zakończone - puste produkty", value: 2 },
    ]
    };
  },
};
